export default class CustomEnv {
    static install = (Vue, env) => {
        Object.defineProperty(Vue.prototype, '$customEnv', {
            get() {
                return this.$root._customEnv;
            }
        });

        Vue.mixin({
            beforeCreate() {
                if (!this.$root._customEnv) {
                    this.$root._customEnv = new CustomEnv(env);
                }
            }
        });
    };

    /**
     * @constructor
     * @param env
     */
    constructor(env) {
        this.env_ = env;
    }

    /**
     * @param targetPath
     */
    get(targetPath) {
        let result = this.env_;
        let pathArray = targetPath.split('.');
        pathArray.forEach(function(path) {
            result = result[path];
        });
        if(!result) {
            return '';
        }
        return result.toString();
    }
};



// WEBPACK FOOTER //
// ./src/custom_plugins/env/custom_env.js